import { SupabaseJob } from '@applicator/shared'

import { supabase } from '../../../lib/supabase'

// Helper function to load job description
export async function loadJobDescription(
  jobId: string,
  supabaseJobs: SupabaseJob[],
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>
): Promise<string> {
  const supabaseJob = supabaseJobs.find(j => j.id === jobId)
  if (supabaseJob?.description) {
    return supabaseJob.description
  }

  // Fetch description from Supabase
  const { data, error } = await supabase
    .from('jobs')
    .select('description')
    .eq('id', jobId)
    .single()
  
  if (error || !data) {
    throw new Error(`Failed to load job description: ${error?.message || 'Not found'}`)
  }
  
  const description = data.description || ''
  
  // Update supabaseJob with description
  if (supabaseJob) {
    supabaseJob.description = description
    setSupabaseJobs([...supabaseJobs])
  }
  
  return description
}

// Helper function to update job relevance in Supabase
export async function updateJobRelevanceInDB(
  jobId: string,
  score: number,
  verdict: string | null,
  reasoning: string | null,
  isRelevant: boolean
): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser()
  if (!user) {
    throw new Error('User not authenticated')
  }
  
  const { error: updateError } = await supabase
    .rpc('update_job_relevance', {
      p_user_id: user.id,
      p_job_id: jobId,
      p_relevance_score: score,
      p_relevance_verdict: verdict,
      p_relevance_reasoning: reasoning,
      p_is_relevant: isRelevant
    })
  
  if (updateError) {
    throw updateError
  }
}

// Helper function to update supabase job in state
export function updateSupabaseJobInState(
  jobId: string,
  score: number,
  verdict: string | null,
  reasoning: string | null,
  isRelevant: boolean,
  setSupabaseJobs: React.Dispatch<React.SetStateAction<SupabaseJob[]>>,
  mapJobsWithUpdatedJob: (prev: SupabaseJob[], jobId: string, score: number, verdict: string | null, reasoning: string | null, isRelevant: boolean) => SupabaseJob[]
) {
  setSupabaseJobs((prev) => mapJobsWithUpdatedJob(prev, jobId, score, verdict, reasoning, isRelevant))
}
